import axios from 'axios'

/**
 * Soft deletes a company from the backend API by id.
 * @param {object} data - The data object with the company id and the notify method for alerts.
 */
export default function deleteCompany ({ commit, state, dispatch }, data) {
  axios.delete(`${process.env.VUE_APP_API_URL}api/companies/${data.company_id}`, {
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': localStorage.getItem('user-token')
    }
  })
    .then(function (response) {
      if (data.level === 0) {
        dispatch('getAllCompanies')
      } else {
        dispatch('getAdminCompanies')
      }

      data.notify({
        group: 'foo-velocity',
        title: `Company successfully deleted!`,
        text: `<br><br>`,
        type: 'success'
      })
    })
    .catch(function (error) {
      console.log(error)
    })
}
